<template>
    <v-container fluid class="pt-0">
        <create-or-update-vacation
            :is-open="isCreateOrUpdateDialogVisible"
            :vacation="selected"
            @close="onCloseCreateOrUpdateDialog"
        />
        <confirm-delete
            :is-open="isConfirmDeleteDialogVisible"
            :selected="selected"
            @confirm="onConfirmDeleteDialog"
            @close="onCloseConfirmDeleteDialog"
        />
        <entity-history
            :isVisible="isShowHistoryDialogVisible"
            :histories="histories"
            @close="onCloseShowHistoryDialog"
        >
            <template #title>
                Vacation Request History
            </template>
        </entity-history>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <h1>{{ $t('vacationRequestsView.title') }}</h1>
                            </v-col>
                            <v-col cols="12">
                                <v-btn
                                    depressed
                                    medium
                                    class="mt-2"
                                    @click="onOpenCreateOrUpdateDialog(false)"
                                    >{{
                                        $t('vacationRequestsView.newVacation')
                                    }}</v-btn
                                >
                            </v-col>
                        </v-row>
                        <vacation-request-list
                            :vacations="vacations"
                            :visibilityConfig="{
                                actions: {
                                    edit: true,
                                    confirm: true,
                                    delete: true,
                                    showHistory: true
                                },
                                search: true,
                                refresh: true,
                                excludeHeaders: isAdmin
                                    ? null
                                    : ['user.firstName', 'user.lastName']
                            }"
                            @create="onOpenCreateOrUpdateDialog"
                            @edit="onOpenCreateOrUpdateDialog"
                            @confirm="onConfirmVacationRequest"
                            @delete="onDeleteItem"
                            @showHistory="onShowHistory"
                            @refresh="onRefresh"
                        />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    name: 'vacations',
    components: {
        VacationRequestList: () => import('@/components/VacationRequestList'),
        CreateOrUpdateVacation: () =>
            import('@/components/CreateOrUpdateVacation'),
        ConfirmDelete: () => import('@/components/ConfirmDelete'),
        EntityHistory: () => import('@/components/EntityHistory')
    },
    data() {
        return {
            isCreateOrUpdateDialogVisible: false,
            isConfirmDeleteDialogVisible: false,
            isShowHistoryDialogVisible: false,
            selected: {},
            histories: []
        };
    },
    computed: {
        ...mapGetters({
            vacations: 'vacations/getVacations',
            isAdmin: 'auth/isAdmin'
        })
    },
    async created() {
        await this.fetchVacations();
    },
    methods: {
        ...mapActions({
            fetchVacations: 'vacations/fetch',
            deleteVacation: 'vacations/delete',
            confirmVacation: 'vacations/confirm',
            fetchHistoriesByVacationId: 'vacations/fetchHistoriesByEntityId'
        }),

        onDeleteItem(item = {}) {
            this.selected = item;
            this.isConfirmDeleteDialogVisible = true;
        },
        async onConfirmDeleteDialog(item) {
            try {
                await this.deleteVacation(item.id);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('vacationRequestsView.vacationTitle'),
                    text: this.$t('vacationRequestsView.deleteSuccess')
                });
            } catch (error) {
                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('vacationRequestsView.vacationTitle'),
                    text: this.$t('vacationRequestsView.deleteError')
                });

                console.error(error);
            }

            this.onCloseConfirmDeleteDialog();
        },
        onCloseConfirmDeleteDialog() {
            this.selected = {};
            this.isConfirmDeleteDialogVisible = false;
        },
        onOpenCreateOrUpdateDialog(item = {}) {
            this.isCreateOrUpdateDialogVisible = true;

            if (item.id) {
                this.selected = item;
            }
        },
        onCloseCreateOrUpdateDialog() {
            this.selected = {};
            this.isCreateOrUpdateDialogVisible = false;
        },
        async onConfirmVacationRequest(item) {
            try {
                await this.confirmVacation(item.id);

                this.$notify({
                    group: 'notify',
                    type: 'success',
                    title: this.$t('createOrUpdateVacation.vacationTitle'),
                    text: this.$t('createOrUpdateVacation.confirmSuccess')
                });
            } catch (err) {
                if (err.response && err.response.status === 404) {
                    this.$notify({
                        group: 'notify',
                        type: 'error',
                        title: this.$t('createOrUpdateVacation.editTitle'),
                        text: this.$t(
                            'createOrUpdateVacation.vacationDoesntExist'
                        )
                    });
                }

                console.error(err);
            }
        },
        async onRefresh() {
            await this.fetchVacations();
        },

        async onShowHistory({ id }) {
            try {
                this.histories = await this.fetchHistoriesByVacationId(id);
            } catch (err) {
                const { response } = err;

                if (response && response.status === 404) {
                    return;
                }

                this.$notify({
                    group: 'notify',
                    type: 'error',
                    title: this.$t('formCommonErrors.commonTitle'),
                    text: this.$t('formCommonErrors.serverError')
                });

                console.error(err);
            } finally {
                this.isShowHistoryDialogVisible = true;
            }
        },

        onCloseShowHistoryDialog() {
            this.histories = [];
            this.isShowHistoryDialogVisible = false;
        }
    }
};
</script>
<style lang="scss"></style>
